<template>
  <div class="container">
    <div class="navi">
        <div class="back"><a @click="close"><img :src="`${publicPath}/images/icons/chevron-left.svg`" class="icon"></a></div>
        <div class="title"><span>プレート一覧</span></div>
        <div class="edit"><a @click="edit"><img :src="`${publicPath}/images/icons/edit.svg`" class="icon"></a></div>
    </div>
    <div class="panels">
      <a v-for="(platePanels, index) in plates" class="panel" :key="index" @click="select(index)">
          <img v-for="(plate, plate_index) in platePanels" :src="answerImagePath(plate)" :key="plate_index" />
      </a>
      <a v-if="customPlates.length" class="panel" @click="select(-1)">
        <span v-for="(plateMark, index) in customPlates" :key="index" :class="customClassName(index)">{{ plateMark }}</span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PlatesComponent',
  data: function() {
    return {
      customPlates: this.getCustomPlateList()
    }
  },
  methods: {
    select: function(plateNumber) {
      this.changeView({
        viewName: 'AnswerListComponent',
        plateNumber: plateNumber
      })
    },
    close: function() {
      this.changeView({
        viewName: 'HomeComponent',
        transitionName: 'left'
      })
    },
    edit: function() {
      var custom = this.getCustomPlate()
      var result = window.prompt('オリジナルのパネルに表示する文字を入力してください（最大5文字）', custom)
      if (result !== null) {
        this.setCustomPlate(result)
        this.customPlates = this.getCustomPlateList()
      }
    }
  }
}
</script>
